module.exports = __webpack_public_path__ + "img/pencil-icon.0723891d.svg";